interface Props {
  /** Avance 0-100. Se recorta al rango. */
  pct: number
  dark: boolean
  /** Variante estrecha para celdas de tabla densa. */
  compact?: boolean
  /** Texto a la derecha en vez del porcentaje (p. ej. "67/130 ud"). */
  label?: string
  title?: string
}

/** Barra de progreso de picking.
 *
 *  Tres colores alineados con los tres estados de carga que se derivan de las
 *  cantidades: sin empezar, en preparación y preparada. Un degradado con más
 *  tramos no aportaría información — el estado sólo tiene esos tres valores.
 */
export function PickingBar({ pct, dark, compact, label, title }: Props) {
  const v = Math.max(0, Math.min(100, Math.round(pct)))
  const fill =
    v >= 100 ? 'bg-emerald-500' :
    v > 0    ? 'bg-amber-500'   :
    dark ? 'bg-slate-600' : 'bg-slate-300'
  const track = dark ? 'bg-slate-700/70' : 'bg-slate-200'
  const txt = dark ? 'text-slate-300' : 'text-slate-600'

  return (
    <div
      className={`flex items-center gap-2 ${compact ? 'min-w-[86px]' : 'min-w-[120px]'}`}
      title={title}
    >
      <div className={`flex-1 ${compact ? 'h-1.5' : 'h-2'} rounded-full overflow-hidden ${track}`}>
        <div
          className={`h-full ${fill} rounded-full transition-all duration-500`}
          style={{ width: `${v}%` }}
        />
      </div>
      <span className={`${compact ? 'text-[10px]' : 'text-[11px]'} font-semibold tabular-nums text-right shrink-0 ${txt}`}>
        {label ?? `${v}%`}
      </span>
    </div>
  )
}
